import { http } from '../../http';

export default {
  subscribeByEmail(email) {
    return http.get(`/email/subscribe?email=${email}`);
  },
};
